import { api } from './api'
import authReducer from './auth/authSlice'
import uploadReducer from './driveUpload/uploadSlice'
import companyReducer from './companies/companySlice'
import campaignsReducer from './campaigns/campaignsSlice'
import subscriptionReducer from './Subscription/SubscriptionSlice'
import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import bmAccountReducer from './BmAccounts/bmAccountSlice'
import aiReducer from './aiHub/aiSlice'

export const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        auth: authReducer,
        upload: uploadReducer,
        company: companyReducer,
        campaigns: campaignsReducer,
        bmAccounts: bmAccountReducer,
        subscription: subscriptionReducer,
        aiHub: aiReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(api.middleware),
})

setupListeners(store.dispatch)